// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YE59","label":"styles_label__16Lph"};